import transfrRibbon from "../../../public/images/transfr-ribbon.svg";
import clsx from "clsx";
import { Credential } from "@components/credential";

export const AwardsProgressTracker = ({
  mainCredential,
  courseInfo,
  userCredInfo,
  mainActions,
  isStudentView = false,
}) => {
  return (
    <div className="course-main-container">
      <img
        src={transfrRibbon}
        alt="Transfr Ribbon"
        className="transfr-ribbon"
      />
      {mainCredential && (
        <div className="course-main-container-wrapper">
          <div className="main-certificate-container">
            <Credential
              isMain
              courseInfo={mainCredential}
              userCredInfo={isStudentView ? userCredInfo : undefined}
            />
            {mainActions && (
              <div className="certificate-export-button">{mainActions}</div>
            )}
          </div>
        </div>
      )}
      <div
        className={clsx(
          "minor-certificates-container",
          !mainCredential && "all-minor-creds"
        )}
      >
        {courseInfo.map((info, index) => (
          <Credential
            courseInfo={info}
            userCredInfo={isStudentView ? userCredInfo : undefined}
            key={`credential-${index}`}
          />
        ))}
      </div>
    </div>
  );
};
